import axios from "axios";
import { ServerSideTypes } from "../../../types/OperationCommonTypes";
import { ETollTypes } from "../tasks/Types";

const ETollImportService = {
    get: {
        rfidStatus: () => {
            return axios.get<string[]>("/masterdatavehicle/etollimporttracking/status/all").then(
                (response) => response.data,
            )
        },
        all: (tenant: string, data: ETollTypes.IFormInput, params: ServerSideTypes.IParams) => {
            return axios.get<ServerSideTypes.IResult<ETollTypes.IETollResponse>>("/masterdatavehicle/etollimporttracking", {
                params: {
                    tenant,
                    ...data,
                    ...params,
                }
            }).then(
                response => response.data,
            )
        },
        excel: (tenant: string, data: ETollTypes.IFormInput) => {
            return axios.get(`/masterdatavehicle/etollimporttracking/excel`, {
                params: {
                    tenant: tenant, ...data,
                },
                responseType: "arraybuffer"
            }).then(
                (response) => response,
            )
        },
        file: (tenant: string, id: number) => {
            return axios.get(`/masterdatavehicle/etollimporttracking/${id}/file`,
                {
                    params: { tenant },
                    responseType: "arraybuffer",
                }).then(
                    response => response,
                )
        },
        errorFile: (tenant: string, id: number) => {
            return axios.get(`/masterdatavehicle/etollimporttracking/${id}/errorfile`,
                {
                    params: { tenant },
                    responseType: "arraybuffer",
                }).then(
                    response => response,
                )
        }
    }
}
export default ETollImportService;
